import React from 'react';

//Componentes
import TableContainer from '../../components/table/TableContainer';

//Estilos
import './DJTVList.css';

function DJTVList({ functions, states }) {
    const {
        register,
        handleSubmit,
        formState: { errors },
        newDJTV,
    } = functions;

    const { DJTVListData, tableData, viniedos, settings, EnableBtn } = states;

    return (
        <div className="DJTVList-container">
            {DJTVListData.length > 0 ? (
                <>
                    <TableContainer tableData={tableData} />
                </>
            ) : (
                <h3>No tiene ninguna Declaración de Transferencia de Viñedo</h3>
            )}
            {new Date(settings?.djcp_rango_inicio) <
                new Date() <
                new Date(settings?.djcp_rango_fin) && (
                <div className="DJTVList-footer">
                    <form onSubmit={handleSubmit(newDJTV)}>
                        <select {...register('myViniedo')}>
                            <option value={0}>Elegir Viñedo</option>
                            {viniedos?.map((v) => {
                                return (
                                    <option key={v.id} value={v.id}>
                                        {v.num}
                                    </option>
                                );
                            })}
                        </select>
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={EnableBtn === 0}
                        >
                            Nueva DJTV
                        </button>
                    </form>
                </div>
            )}
        </div>
    );
}

export default DJTVList;
